import { ENV } from '@/app/config';
import type { TABTestConfig, TABTestState } from './ab-test.types';

const PARAM_NAME = 'abTestMonitor';
const ALLOWED_ENVS = ['development', 'homologation', 'blue'];

const isDebugEnabled = (): boolean => {
	if (typeof window === 'undefined') return false;

	const env = ENV.DATADOG_ENV;
	if (!ALLOWED_ENVS.includes(env)) return false;

	return new URLSearchParams(window.location.search).has(PARAM_NAME);
};

/**
 * Logs a formatted table of all A/B test states to the console.
 * Only runs in dev/hml/blue environments when ?abTestMonitor is in the URL.
 *
 * Usage: navigate to any page with ?abTestMonitor appended to the URL.
 */
const exposeABTestDebug = (
	tests: Record<string, TABTestState>,
	configs: TABTestConfig
): void => {
	if (!isDebugEnabled()) return;

	const allFetched = Object.values(tests).every(t => t.fetched);
	if (!allFetched) return;

	const tableData = Object.entries(tests).reduce<Record<string, Record<string, string>>>(
		(acc, [key, state]) => {
			const cfg = configs[key];
			acc[key] = {
				variation: state.variation ?? '(null)',
				status:
					state.variation === 'B'
						? 'ACTIVE (B)'
						: state.variation === 'A'
							? 'CONTROL (A)'
							: 'NOT SET',
				mboxName: cfg?.mboxName ?? '-',
				targetKey: cfg?.key ?? '-'
			};
			return acc;
		},
		{}
	);

	/* eslint-disable no-console */
	console.log(
		'\n%c[AB Test Monitor] %c' + new Date().toLocaleTimeString(),
		'color: #9C27B0; font-weight: bold; font-size: 14px;',
		'color: #666; font-weight: normal; font-size: 12px;'
	);
	console.log(
		`%cTestes registrados: ${String(Object.keys(tests).length)} | Env: ${ENV.DATADOG_ENV}`,
		'color: #666;'
	);
	console.table(tableData);
	/* eslint-enable no-console */
};

export { exposeABTestDebug };
